<ng-template #recursiveList let-elements let-state="state" let-formRow="formRow">
  <div *ngFor="let component of elements">
    <ng-container [ngSwitch]="component.machineName">
      <ng-container *ngTemplateOutlet="sectionTpl; context: { $implicit: component, state, formRow }"></ng-container>
      <app-text *ngSwitchCase="'text'" [component]="component" [viewOnly]="true"></app-text>
      <app-picture *ngSwitchCase="'picture'" [component]="component"></app-picture>
      <app-button *ngSwitchCase="'button'" [component]="component"></app-button>
      <app-textarea *ngSwitchCase="'textarea'" [component]="component"
        [formDesign]="subscriptionForm.content_dnd.form_design" (onChangeEmitter)="onChangeEmitter($event, formRow)"
        [formState]="state"></app-textarea>
      <app-spacer *ngSwitchCase="'spacer'" [component]="component"></app-spacer>
      <app-separator *ngSwitchCase="'separator'" [component]="component"></app-separator>
      <app-social *ngSwitchCase="'social'" [component]="component"></app-social>
      <app-checkbox *ngSwitchCase="'checkbox'" [component]="component"
        [formDesign]="subscriptionForm.content_dnd.form_design" (onChangeEmitter)="onChangeEmitter($event, formRow)"
        [formState]="state"></app-checkbox>
      <app-dropdown *ngSwitchCase="'dropdown'" [component]="component"
        [formDesign]="subscriptionForm.content_dnd.form_design" (onChangeEmitter)="onChangeEmitter($event, formRow)"
        [formState]="state"></app-dropdown>
      <app-radios *ngSwitchCase="'radios'" [component]="component"
        [formDesign]="subscriptionForm.content_dnd.form_design" (onChangeEmitter)="onChangeEmitter($event, formRow)"
        [formState]="state"></app-radios>
      <app-input *ngSwitchCase="'input'" [component]="component" [formDesign]="subscriptionForm.content_dnd.form_design"
        (onChangeEmitter)="onChangeEmitter($event, formRow)" [formState]="state"></app-input>
      <app-uploader *ngSwitchCase="'uploader'" [component]="component"
        [formDesign]="subscriptionForm.content_dnd.form_design"></app-uploader>
      <app-table *ngSwitchCase="'table'" [component]="component" [formDesign]="subscriptionForm.content_dnd.form_design"
        (onChangeEmitter)="onChangeEmitter($event, formRow)" [formState]="state"></app-table>
      <app-toggle *ngSwitchCase="'toggle'" [component]="component"
        [formDesign]="subscriptionForm.content_dnd.form_design" (onChangeEmitter)="onChangeEmitter($event, formRow)"
        [formState]="state"></app-toggle>
      <app-output *ngSwitchCase="'output'" [component]="component"
        [formDesign]="subscriptionForm.content_dnd.form_design" [formState]="state"></app-output>
      <app-client-location-selector *ngSwitchCase="'clientLocationSelector'" [component]="component"
        [formDesign]="subscriptionForm.content_dnd.form_design" [formState]="state"
        (onChangeEmitter)="onChangeEmitter($event, formRow)"></app-client-location-selector>
    </ng-container>
  </div>
</ng-template>

<ng-template #sectionTpl let-component let-state="state" let-formRow="formRow">
  <div class="row no-gutters" [ngSwitch]="component.column" *ngIf="condition(component.element)">
    <ng-container *ngSwitchCase="'2-1-3'">
      <div class="col-4 section-area" [ngClass]="{
          'not-added-component': component.addedComponents[0].length === 0
        }">
        <ng-container *ngTemplateOutlet="
            recursiveList;
            context: { $implicit: component.addedComponents[0], state, formRow }
          ">
        </ng-container>
      </div>
      <div class="col-8 section-area" [ngClass]="{
          'not-added-component': component.addedComponents[1].length === 0
        }">
        <ng-container *ngTemplateOutlet="
            recursiveList;
            context: { $implicit: component.addedComponents[1], state, formRow }
          ">
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'2-3-1'">
      <div class="col-8 section-area" [ngClass]="{
          'not-added-component': component.addedComponents[0].length === 0
        }">
        <ng-container *ngTemplateOutlet="
            recursiveList;
            context: { $implicit: component.addedComponents[0], state, formRow }
          ">
        </ng-container>
      </div>
      <div class="col-4 section-area" [ngClass]="{
          'not-added-component': component.addedComponents[1].length === 0
        }">
        <ng-container *ngTemplateOutlet="
            recursiveList;
            context: { $implicit: component.addedComponents[1], state, formRow }
          ">
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <div class="col section-area" *ngFor="let c of component.addedComponents; let i = index" [ngClass]="{
          'not-added-component': component.addedComponents[i].length === 0
        }">
        <ng-container *ngTemplateOutlet="
            recursiveList;
            context: { $implicit: component.addedComponents[i], state, formRow }
          ">
        </ng-container>
      </div>
    </ng-container>
  </div>
</ng-template>

<section>
  <div *ngIf="subscriptionForm">
    <div class="d-flex justify-content-between px-3">
      <div class="form-body flex-grow-1">
        <div class="email-body d-flex content-droppable-zone {{
            dragStartClass
          }} dndList" [ngClass]="{
            'align-items-start':
              subscriptionForm.content_dnd.form_design.page_alignment === 'top',
            'align-items-center':
              subscriptionForm.content_dnd.form_design.page_alignment === 'center',
            'align-items-end':
              subscriptionForm.content_dnd.form_design.page_alignment === 'bottom'
          }" [ngStyle]="{
            'font-family':
              subscriptionForm.content_dnd.form_design.font_family,
            'font-size':
              subscriptionForm.content_dnd.form_design.font_size + 'px',
            background:
              subscriptionForm.content_dnd.form_design.background_color,
            padding:
              subscriptionForm.content_dnd.form_design.page_paddings + 'px'
          }">
          <div class="form-container mx-auto" [ngClass]="formViewClass" [ngStyle]="{
              width: subscriptionForm.content_dnd.form_design.fullWidth
                ? '100%'
                : subscriptionForm.content_dnd.form_design.width + 'px',
              'background-color':
                subscriptionForm.content_dnd.form_design
                  .container_background_color,
              'border-radius':
                subscriptionForm.content_dnd.form_design.rounded_corners +
                'px',
              padding:
                subscriptionForm.content_dnd.form_design.form_paddings + 'px',
              border:
                'solid ' +
                subscriptionForm.content_dnd.form_design.form_border_width +
                'px ' +
                subscriptionForm.content_dnd.form_design.form_border_color
            }">



            <ng-container *ngIf="subscriptionForm.content_dnd.form_design.formType == 'recursive'">
              <ng-container *ngTemplateOutlet="recursive;context: {
                formRefName: subscriptionForm.content_dnd.form_design.form_name
              }"></ng-container>
            </ng-container>

            <ng-container *ngIf="subscriptionForm.content_dnd.form_design.formType != 'recursive'">
              <ng-container *ngTemplateOutlet="standard"></ng-container>
            </ng-container>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #standard>
  <div class="position-relative">
    <div [ngClass]="{'disabled': disabled == true}">
      <ng-container *ngTemplateOutlet="
        recursiveList;
        context: {
          $implicit: subscriptionForm.content_dnd.added_components,
          state: formState
        }
      "></ng-container>
    </div>
  </div>

</ng-template>

<ng-template #recursive class="position-relative" let-formRefName="formRefName">
  <div class="row mb-2">
    <div class="col-12">
      <button *ngIf="!disabled" class="float-end h-100 btn btn-primary" (click)="onChangeEmitter({
        eventType: 'AddRecursiveForm'
      })">Add</button>
    </div>
  </div>
  <ngb-accordion #acc="ngbAccordion" activeIds="ngb-panel-0">
    <ng-container *ngFor="let rState of formState[formId]; index as i">
      <ngb-panel title="{{rState[formRefName] ?? ('item #' + i)}}">
        <ng-template ngbPanelContent>
          <div class="position-relative">
            <div class="row mt-2">
              <div class="col-12">
                <dx-button type="danger" text="Delete" class="float-end" (click)="onChangeEmitter({
                    eventType: 'ConfirmRemoveRecursiveForm',
                    formId: formId
                  }, i)"></dx-button>
              </div>
            </div>
            <div [ngClass]="{'disabled': disabled == true}">
              <ng-container *ngTemplateOutlet="
              recursiveList;
              context: {
                $implicit: subscriptionForm.content_dnd.added_components,
                state: rState,
                formRow: i
              }
            "></ng-container>
            </div>
          </div>
        </ng-template>
      </ngb-panel>
    </ng-container>
  </ngb-accordion>
</ng-template>